export const BILLSBY_CONFIG = {
  companyId: process.env.REACT_APP_BILLSBY_COMPANY_ID,
  apiKey: process.env.REACT_APP_BILLSBY_API_KEY,
  environment: process.env.NODE_ENV === 'production' ? 'production' : 'staging',
  version: '2'
};

export const initializeBillsby = () => new Promise((resolve, reject) => {
  if (window.billsbyTokens && window.billsbyTokens.isInitialized) {
    resolve(window.billsbyTokens);
  } else if (!window.billsbyTokens) {
    reject(new Error('Billsby not loaded'));
  } else {
    window.billsbyTokens.initialize(BILLSBY_CONFIG)
      .then(resolve)
      .catch(reject);
  }
}); 


// WEBPACK FOOTER //
// ./src/config/billsby.js